import React, { useEffect, useMemo } from "react";
import { Button, message, Select, Switch, Table } from "antd";
import dayjs from "dayjs";
import { useHistory, useRouteMatch } from "react-router-dom";
import { axios, getToken, URL_API } from "../../../../../utils";
const { Option } = Select;

const TableEvent = ({
  tableData = [],
  fetchData,
  setLoading,
  setSearchParams,
  searchParams,
}) => {
  const history = useHistory();
  const match = useRouteMatch();
  const sortSelect = useMemo(() => {
    return Array.from({ length: tableData.total }, (_, i) => i + 1);
  }, [tableData]);
  const columns = [
    {
      title: "Sort",
      dataIndex: "seq",
      key: "seq",
      width: 80,
      render: (text, record) => (
        <Select
          style={{ width: "100%" }}
          value={text}
          onChange={(value) =>
            changeSeq(record.id, {
              seq: value,
            })
          }
        >
          {sortSelect.map((e, i) => (
            <Option key={i} value={e}>
              {e}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "ชื่อโปรเจ็กต์",
      dataIndex: "title",
      key: "title",
      width: 300,
    },
    {
      title: "Prefix Serial",
      dataIndex: "prefix_serial",
      key: "prefix_serial",
      width: 150,
    },
    {
      title: "แหล่งที่มา",
      dataIndex: "source_type_name",
      key: "source_type_name",
      width: 150,
    },
    {
      title: "Type",
      dataIndex: "display_type_name",
      key: "display_type_name",
      width: 150,
    },
    {
      title: "Last Update",
      dataIndex: "update_date",
      key: "update_date",
      width: 150,
      render: (text) => dayjs(text).format("DD/MM/YYYY HH:mm"),
    },
    {
      title: "OnAir Date",
      dataIndex: "on_air_start",
      key: "on_air_start",
      width: 150,
      render: (text) => (text ? dayjs(text).format("DD/MM/YYYY") : "-"),
    },
    {
      title: "เปิด/ปิด thumbnail",
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (text, record) => (
        <Switch
          disabled={checkPeriod(record) === "close"}
          checked={text === "active"}
          onChange={(checked) =>
            changeStatus(record.id, {
              status: checked ? "active" : "in-active",
            })
          }
        />
      ),
    },
    {
      title: "thumbnailStartDate",
      dataIndex: "thumbnail_start",
      key: "thumbnail_start",
      width: 180,
      render: (text) => dayjs(text).format("DD/MM/YYYY HH:mm"),
    },
    {
      title: "thumbnailEndDate",
      dataIndex: "thumbnail_end",
      key: "thumbnail_end",
      width: 180,
      render: (text) => dayjs(text).format("DD/MM/YYYY HH:mm"),
    },
    {
      title: "PeriodStartDate",
      dataIndex: "period_start",
      key: "period_start",
      width: 180,
      render: (text, record) =>
        record.source !== "channel"
          ? dayjs(text).format("DD/MM/YYYY HH:mm")
          : "-",
    },
    {
      title: "PeriodEndDate",
      dataIndex: "period_end",
      key: "period_end",
      width: 180,
      render: (text, record) =>
        record.source !== "channel"
          ? dayjs(text).format("DD/MM/YYYY HH:mm")
          : "-",
    },
    {
      title: "Show",
      key: "show",
      width: 100,
      render: (_, record) => {
        return checkPeriod(record);
      },
    },
    {
      title: "",
      width: 100,
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => history.push(`/events/legacy-channel/${record.id}`)}
        >
          Edit
        </Button>
      ),
    },
  ];
  const checkPeriod = (record) => {
    const now = dayjs();
    const start = record.thumbnail_start ? dayjs(record.thumbnail_start) : null;
    const end = record.thumbnail_end ? dayjs(record.thumbnail_end) : null;

    if (!start || !end) return "-";

    if (now.isBefore(start)) return "waiting";
    if (now.isAfter(end)) return "close";
    if (record.status === "in-active") return "hide";
    return "opening";
  };

  const changeStatus = async (id, body) => {
    try {
      await axios.post(`${URL_API}/channel/${id}/status`, body, {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      });
      message.success("อัปเดทสำเร็จ");
    } catch (error) {
      message.error(error);
    } finally {
      setLoading(false);
      fetchData();
    }
  };
  const changeSeq = async (id, body) => {
    try {
      await axios.post(`${URL_API}/channel/${id}/seq`, body, {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      });
      message.success("อัปเดทสำเร็จ");
    } catch (error) {
      message.error(error);
    } finally {
      setLoading(false);
      fetchData();
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <Table
        columns={columns}
        dataSource={tableData.data || []}
        rowKey={(record) => record.id}
        scroll={{
          x: "max-content",
        }}
        onChange={(pagination) => {
          const { current, pageSize } = pagination;
          setSearchParams((prev) => ({
            ...prev,
            limit: pageSize,
            offset: (current - 1) * pageSize,
          }));
        }}
        pagination={{
          pageSize: 10,
          current: searchParams.offset / searchParams.limit + 1,
          total: tableData.total,
        }}
      />
    </div>
  );
};

export default TableEvent;
